import { LegalShell } from './LegalShell';

// PLACEHOLDER copy — Legal team must replace before production.

export function CookiesPage() {
  return (
    <LegalShell title="Cookies Policy" effectiveDate="2026-08-03">
      <div className="bg-warning-soft border border-warning/40 rounded p-3 text-[11px] text-warning-strong">
        <strong>PLACEHOLDER:</strong> Legal team replaces this document before production release.
      </div>

      <section>
        <h2 className="font-bold text-navy">1. What we store on your device</h2>
        <p>
          DreamTrials uses only <em>strictly necessary</em> browser storage to
          keep you signed in and to remember your preferences during a session.
          We do not use tracking cookies, third-party analytics cookies, or
          advertising cookies.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">2. Storage inventory</h2>
        <table className="w-full text-[11.5px] border border-border-strong">
          <thead className="bg-app text-left">
            <tr>
              <th className="p-2 border-b border-border-strong">Item</th>
              <th className="p-2 border-b border-border-strong">Purpose</th>
              <th className="p-2 border-b border-border-strong">Lifetime</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-2 border-b border-border-strong">sessionStorage['dreamtrials:session']</td>
              <td className="p-2 border-b border-border-strong">Holds your signed-in access token (JWT) for the current tab.</td>
              <td className="p-2 border-b border-border-strong">Until you close the tab or sign out.</td>
            </tr>
            <tr>
              <td className="p-2 border-b border-border-strong">sessionStorage['dreamtrials:challenge']</td>
              <td className="p-2 border-b border-border-strong">Temporary token that bridges the password step and the MFA step.</td>
              <td className="p-2 border-b border-border-strong">Up to 5 minutes.</td>
            </tr>
            <tr>
              <td className="p-2 border-b border-border-strong">localStorage['dreamtrials.external.session']</td>
              <td className="p-2 border-b border-border-strong">External reviewer session (magic-link + OTP) — separate from staff sessions.</td>
              <td className="p-2 border-b border-border-strong">Up to 15 minutes; auto-revoked when the grant window ends.</td>
            </tr>
            <tr>
              <td className="p-2">localStorage['consent_embed_&lt;id&gt;']</td>
              <td className="p-2">Lets a subject resume a partially-completed remote consent session on the same device.</td>
              <td className="p-2">Cleared automatically when the session ends.</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2 className="font-bold text-navy">3. Managing storage</h2>
        <p>
          You can clear browser storage at any time via your browser&rsquo;s
          settings. Clearing will sign you out and require re-authentication.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">4. Third parties</h2>
        <p>
          DreamTrials does not embed third-party analytics or advertising
          scripts. The only external service loaded in the browser is DocuSeal,
          which powers e-signature flows and only appears inside signing pages
          you explicitly opened.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-navy">5. Questions</h2>
        <p>
          <a href="mailto:support@zertain.com" className="text-blue">support@zertain.com</a>
          {' '}or your Site Administrator.
        </p>
      </section>
    </LegalShell>
  );
}
